import { useNavigate } from "react-router-dom";

// Seção "Encontre parceiros de jornada e também sua Rede de Apoio" — reutilizada
// em Home, Planos e Contato (fiel ao Figma).
export function CtaRedeApoio() {
  const navigate = useNavigate();
  return (
    <section className="mc-container py-16 md:py-24" data-testid="cta-rede-apoio">
      <div className="grid md:grid-cols-3 gap-8 items-center">
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e1b2e] leading-tight">
            Encontre <span className="text-grad">parceiros</span> de jornada e também sua <span className="text-grad">Rede de Apoio</span>
          </h2>
          <p className="text-muted-foreground mt-5 max-w-sm">Pronto para encontrar alguém compatível com você?</p>
        </div>
        <div className="flex justify-center">
          <img src="https://images.unsplash.com/photo-1758526213774-8ae08c1d48c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=700"
            alt="Duas pessoas conversando" loading="lazy"
            className="w-full max-w-[360px] h-[280px] object-cover rounded-[36px] rounded-tr-[80px] shadow-xl" />
        </div>
        <div className="flex flex-col items-start md:items-center gap-6">
          <div className="mc-card px-7 py-5">
            <div className="text-3xl font-extrabold text-[#1e1b2e]">100<span className="text-lg align-top">%</span></div>
            <div className="text-sm text-muted-foreground">Conexões reais</div>
          </div>
          <button className="btn-primary" data-testid="cta-cadastro-btn" onClick={() => navigate("/cadastro")}>Fazer meu cadastro</button>
        </div>
      </div>
    </section>
  );
}
